export default __webpack_public_path__ + "static/media/no-testdrive.33000054.png";